<template>
    <div>
        <b-avatar :style="'background-color:' + userColor" :text="shortUName" v-if="!user.avatar"></b-avatar>
        <b-avatar :src="getAvatar(user.avatar)" v-else></b-avatar>
    </div>
</template>

<script>
    import {api} from '@/utils/api';

    export default {
        props: {
            user: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                colors: ["#a00", "#000", "#00a", "#0a0"]
            }
        },

        computed: {
            /**
             * Get user color
             */

            userColor() {
                return this.colors[(this.user.id) % this.colors.length];
            },

            /**
             * Get short user name
             * @returns {string}
             */
            shortUName() {
                return this.user ? ( (this.user.first_name ? this.user.first_name[0].toUpperCase() : "X") + (this.user.second_name ? this.user.second_name[0].toUpperCase() : "X")) : "N/A";
            }
        },
        methods: {
            getAvatar(avatar) {
                return api.getAvatarUrl(avatar)
            }
        }
    }
</script>


<style lang="scss">

</style>
